import { supabase } from '../supabaseClient'
import type { CalibrationTransitionResult, CompoundLiftSample } from './progressionTypes'

export type CompleteCalibrationTransitionInput = {
  compoundLifts?: CompoundLiftSample[]
  finalSetRir?: number
}

/**
 * Client entry point — invokes the atomic calibration → production transition.
 * Call immediately after the 4th calibration session metrics are persisted and
 * `calibration_completed_sessions` reaches 4.
 */
export async function completeCalibrationTransition(
  input: CompleteCalibrationTransitionInput = {},
): Promise<{ data: CalibrationTransitionResult | null; error: string | null }> {
  const { data, error } = await supabase.functions.invoke('complete-calibration', {
    body: input,
  })

  if (error) return { data: null, error: error.message }
  if (data?.error) return { data: null, error: String(data.error) }

  return { data: data as CalibrationTransitionResult, error: null }
}

export type { CalibrationTransitionResult }
